(function ($) {
    $('.search-filters').find('select').on('change', function () {
        $(this).closest('form').submit();
    });
})(jQuery);